import React from 'react';
import { FaPrint, FaTimes, FaReceipt, FaStore, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const OrderModal = ({ show, onClose, order }) => {
  if (!show) return null;

  // Print functionality
  const handlePrint = () => {
    // Create a comprehensive print-friendly version
    const printHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Order Receipt - ${order.orderID}</title>
          <meta charset="UTF-8">
          <style>
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
            }
            body { 
              font-family: Arial, sans-serif; 
              margin: 20px; 
              color: #333;
              line-height: 1.5;
              background: white;
            }
            .receipt-container {
              max-width: 800px;
              margin: 0 auto;
              background: white;
            }
            .receipt-header { 
              text-align: center; 
              border-bottom: 3px solid #3B82F6; 
              padding-bottom: 20px; 
              margin-bottom: 30px; 
            }
            .company-logo { 
              font-size: 32px; 
              font-weight: bold; 
              color: #3B82F6; 
              margin-bottom: 15px; 
            }
            .company-info { 
              font-size: 14px; 
              color: #666; 
              margin-bottom: 8px; 
            }
            .receipt-title { 
              font-size: 28px; 
              font-weight: bold; 
              color: #333; 
              margin: 25px 0; 
              text-decoration: underline;
            }
            .section { 
              margin-bottom: 30px; 
            }
            .section-title { 
              font-size: 18px; 
              font-weight: bold; 
              color: #3B82F6; 
              border-bottom: 2px solid #E5E7EB; 
              padding-bottom: 10px; 
              margin-bottom: 20px; 
            }
            .info-grid { 
              display: grid; 
              grid-template-columns: 1fr 1fr; 
              gap: 30px; 
              margin-bottom: 25px; 
            }
            .info-box {
              background: #F9FAFB;
              padding: 15px;
              border: 1px solid #E5E7EB;
              border-radius: 8px;
            }
            .info-box h5 {
              font-size: 16px;
              font-weight: bold;
              color: #3B82F6;
              margin-bottom: 12px;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin-bottom: 20px;
              border: 2px solid #3B82F6;
            }
            th { 
              background-color: #3B82F6; 
              color: white;
              font-weight: bold;
              padding: 12px 8px;
              text-align: left;
              border: 1px solid #3B82F6;
            }
            td { 
              padding: 10px 8px;
              text-align: left;
              border: 1px solid #E5E7EB;
            }
            .item-row:nth-child(even) {
              background-color: #F9FAFB;
            }
            .total-section {
              background: #F3F4F6;
              padding: 20px;
              border: 2px solid #3B82F6;
              border-radius: 8px;
              margin-top: 20px;
            }
            .total-row { 
              background-color: #FEF3C7; 
              font-weight: bold;
              font-size: 16px;
            }
            .paid-row {
              background-color: #D1FAE5;
              font-weight: bold;
              font-size: 16px;
            }
            .footer { 
              text-align: center; 
              border-top: 3px solid #3B82F6; 
              padding-top: 20px; 
              margin-top: 40px; 
              font-size: 14px; 
              color: #666; 
            }
            .status-badge {
              display: inline-block;
              padding: 6px 12px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: bold;
              text-transform: uppercase;
            }
            .status-delivered { background: #D1FAE5; color: #065F46; }
            .status-shipped { background: #DBEAFE; color: #1E40AF; }
            .status-processing { background: #FEF3C7; color: #92400E; }
            .status-default { background: #F3F4F6; color: #374151; }
            
            @media print {
              body { 
                margin: 0; 
                padding: 15px;
                font-size: 12px;
              }
              .receipt-container {
                max-width: none;
              }
              .info-grid {
                grid-template-columns: 1fr;
                gap: 20px;
              }
              .section {
                page-break-inside: avoid;
                margin-bottom: 25px;
              }
              .receipt-header {
                page-break-after: avoid;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            <!-- Receipt Header -->
            <div class="receipt-header">
              <div style="margin-bottom: 15px;">
                <img src="https://minimartke-products-upload.s3.us-east-1.amazonaws.com/product-images/e4dabde0-e9b7-4b2c-b397-247b659efc13.png" 
                     alt="QuickCrate Express Logo" 
                     style="height: 60px; width: auto; margin: 0 auto; display: block;">
              </div>
              <div class="company-logo">QuickCrate Express</div>
              <div class="company-info">📍 123 Commerce Street, Business District</div>
              <div class="company-info">📞 +254 720 463 710</div>
              <div class="company-info">✉️ support@quickcrate.co.ke</div>
              <div class="receipt-title">📄 ORDER RECEIPT</div>
            </div>

            <!-- Order Information -->
            <div class="section">
              <h4 class="section-title">Order Information</h4>
              <div class="info-grid">
                <div class="info-box">
                  <table style="border: none;">
                    <tr>
                      <td style="border: none; font-weight: bold; color: #374151;">Order ID:</td>
                      <td style="border: none; font-weight: bold; color: #3B82F6; font-family: monospace;">#${order.orderID}</td>
                    </tr>
                    <tr>
                      <td style="border: none; font-weight: bold; color: #374151;">Status:</td>
                      <td style="border: none;">
                        <span class="status-badge ${
                          order.status?.toLowerCase().includes('delivered') ? 'status-delivered' :
                          order.status?.toLowerCase().includes('shipped') ? 'status-shipped' :
                          order.status?.toLowerCase().includes('processing') ? 'status-processing' :
                          'status-default'
                        }">
                          ${order.status || 'Unknown'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="border: none; font-weight: bold; color: #374151;">Order Date:</td>
                      <td style="border: none;">${new Date(order.orderDate).toLocaleDateString('en-US', { 
                        weekday: 'long', 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric' 
                      })}</td>
                    </tr>
                    <tr>
                      <td style="border: none; font-weight: bold; color: #374151;">Print Date:</td>
                      <td style="border: none;">${new Date().toLocaleDateString('en-US', { 
                        weekday: 'long', 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}</td>
                    </tr>
                  </table>
                </div>

                <div class="info-box">
                  <h5>📍 Shipping Address</h5>
                  ${order.shippingAddress ? 
                    Object.entries(order.shippingAddress).map(([key, value]) => 
                      `<div style="margin-bottom: 8px;">
                        <strong>${key.replace(/([A-Z])/g, ' $1').trim()}:</strong> ${value}
                      </div>`
                    ).join('') : 
                    '<div style="color: #9CA3AF; font-style: italic;">No shipping address provided</div>'
                  }
                </div>
              </div>
            </div>

            <!-- Products Section -->
            <div class="section">
              <h4 class="section-title">Order Items</h4>
              <table>
                <thead>
                  <tr>
                    <th style="width: 5%;">#</th>
                    <th style="width: 50%;">Product Name</th>
                    <th style="width: 10%; text-align: center;">Qty</th>
                    <th style="width: 15%; text-align: right;">Unit Price</th>
                    <th style="width: 20%; text-align: right;">Total</th>
                  </tr>
                </thead>
                <tbody>
                  ${order.products.map((product, index) => `
                    <tr class="item-row">
                      <td style="text-align: center; font-weight: bold; color: #6B7280;">${index + 1}</td>
                      <td style="font-weight: 500;">${product.productName}</td>
                      <td style="text-align: center; font-weight: bold;">${product.quantity}</td>
                      <td style="text-align: right; font-weight: bold;">$${product.price.toFixed(2)}</td>
                      <td style="text-align: right; font-weight: bold; color: #3B82F6;">$${(product.price * product.quantity).toFixed(2)}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>

            <!-- Payment Information -->
            ${order.paymentDetails && order.paymentDetails.length > 0 ? `
            <div class="section">
              <h4 class="section-title">Payment Information</h4>
              <table>
                <thead>
                  <tr>
                    <th>Reference</th>
                    <th>Method</th>
                    <th>Phone</th>
                    <th style="text-align: right;">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  ${order.paymentDetails.map(payment => `
                    <tr>
                      <td style="font-family: monospace; font-size: 11px;">${payment.paymentReference}</td>
                      <td style="font-weight: bold;">${payment.paymentMethod}</td>
                      <td>${payment.phonenumber}</td>
                      <td style="text-align: right; font-weight: bold;">$${payment.amount.toFixed(2)}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
            ` : ''}

            <!-- Order Summary -->
            <div class="section">
              <h4 class="section-title">Order Summary</h4>
              <div class="total-section">
                <table style="border: 1px solid #D1D5DB;">
                  <tr>
                    <td style="font-weight: bold; color: #374151; border-bottom: 1px solid #E5E7EB;">Subtotal:</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 1px solid #E5E7EB;">$${order.products.reduce((sum, product) => sum + (product.price * product.quantity), 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold; color: #374151; border-bottom: 1px solid #E5E7EB;">Delivery Fees:</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 1px solid #E5E7EB;">$${(order.totalDeliveryFees || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold; color: #374151; border-bottom: 1px solid #E5E7EB;">Tax:</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 1px solid #E5E7EB;">$${(order.totalTax || 0).toFixed(2)}</td>
                  </tr>
                  <tr class="total-row">
                    <td style="font-weight: bold; font-size: 16px; color: #1F2937; padding: 15px 8px;">TOTAL AMOUNT:</td>
                    <td style="text-align: right; font-weight: bold; font-size: 16px; color: #3B82F6; padding: 15px 8px;">$${(order.totalOrderAmount || 0).toFixed(2)}</td>
                  </tr>
                  <tr class="paid-row">
                    <td style="font-weight: bold; font-size: 16px; color: #1F2937; padding: 15px 8px;">AMOUNT PAID:</td>
                    <td style="text-align: right; font-weight: bold; font-size: 16px; color: #059669; padding: 15px 8px;">$${(order.totalPaymentAmount || 0).toFixed(2)}</td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Footer -->
            <div class="footer">
              <p style="font-size: 18px; font-weight: bold; color: #3B82F6; margin-bottom: 10px;">
                Thank you for choosing QuickCrate Express! 🙏
              </p>
              <p style="margin-bottom: 10px;">
                For support or inquiries, contact us at support@quickcrate.co.ke or +254 720 463 710
              </p>
              <p style="font-size: 12px; color: #6B7280; margin-bottom: 15px;">
                This is a computer-generated receipt. Please keep it for your records.
              </p>
              <div style="font-size: 11px; color: #9CA3AF;">
                Receipt generated on ${new Date().toLocaleString()}
              </div>
            </div>
          </div>
        </body>
      </html>
    `;

    // Create and open print window
    const printWindow = window.open('', '_blank', 'width=800,height=900,scrollbars=yes');
    if (printWindow) {
      printWindow.document.write(printHTML);
      printWindow.document.close();
      
      // Wait for content to load, then print
      printWindow.onload = function() {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          // Don't auto-close to let user see the preview
        }, 500);
      };
    } else {
      alert('Please allow popups to print the receipt');
    }
  };

  const calculateSubtotal = () => {
    return order.products.reduce((sum, product) => sum + (product.price * product.quantity), 0);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-5xl mx-auto relative border border-blue-200">
        
        {/* Action Buttons */}
        <div className="absolute top-4 right-4 flex gap-3 no-print z-10">
          <button
            onClick={handlePrint}
            className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 shadow-md"
            title="Print Receipt"
          >
            <FaPrint className="text-sm" />
            <span className="text-sm font-medium">Print</span>
          </button>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors duration-200 shadow-md"
            title="Close"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>

        {/* Receipt Content */}
        <div id="receipt-content" className="p-8">
          
          {/* Receipt Header */}
          <div className="receipt-header text-center border-b-2 border-blue-500 pb-6 mb-8">
            <div className="mb-4">
              <img 
                src="https://minimartke-products-upload.s3.us-east-1.amazonaws.com/product-images/e4dabde0-e9b7-4b2c-b397-247b659efc13.png" 
                alt="QuickCrate Express Logo" 
                className="h-16 w-auto mx-auto"
              />
            </div>
            <div className="company-logo text-3xl font-bold text-blue-600 mb-3">
              QuickCrate Express
            </div>
            <div className="company-info text-gray-600 space-y-1">
              <div className="flex items-center justify-center gap-2">
                <FaMapMarkerAlt className="text-sm" />
                <span>123 Commerce Street, Business District</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <FaPhone className="text-sm" />
                <span>+254 720 463 710</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <FaEnvelope className="text-sm" />
                <span>support@quickcrate.co.ke</span>
              </div>
            </div>
            <div className="receipt-title text-2xl font-bold text-gray-800 mt-6 flex items-center justify-center gap-2">
              <FaReceipt className="text-xl" />
              ORDER RECEIPT
            </div>
          </div>

          {/* Order Information */}
          <div className="section">
            <h4 className="section-title text-lg font-bold text-blue-600 border-b-2 border-blue-200 pb-3 mb-4">
              Order Information
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <table className="w-full">
                  <tbody>
                    <tr>
                      <td className="font-semibold py-2 text-gray-700">Order ID:</td>
                      <td className="py-2 font-mono text-blue-600 font-bold">#{order.orderID}</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2 text-gray-700">Status:</td>
                      <td className="py-2">
                        <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                          order.status?.toLowerCase().includes('delivered') ? 'bg-green-100 text-green-800' :
                          order.status?.toLowerCase().includes('shipped') ? 'bg-blue-100 text-blue-800' :
                          order.status?.toLowerCase().includes('processing') ? 'bg-yellow-100 text-yellow-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {order.status}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2 text-gray-700">Order Date:</td>
                      <td className="py-2">{new Date(order.orderDate).toLocaleDateString('en-US', { 
                        weekday: 'long', 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric' 
                      })}</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2 text-gray-700">Print Date:</td>
                      <td className="py-2">{new Date().toLocaleDateString('en-US', { 
                        weekday: 'long', 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Shipping Address */}
              <div className="bg-blue-50 p-4 rounded-lg">
                <h5 className="text-md font-semibold text-blue-700 mb-3 flex items-center gap-2">
                  <FaMapMarkerAlt />
                  Shipping Address
                </h5>
                {order.shippingAddress ? (
                  <div className="space-y-2 text-gray-700">
                    {Object.entries(order.shippingAddress).map(([key, value], index) => (
                      <div key={index} className="flex">
                        <span className="font-semibold min-w-[100px] capitalize">
                          {key.replace(/([A-Z])/g, ' $1').trim()}:
                        </span>
                        <span className="ml-2">{value}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 italic">No shipping address provided</p>
                )}
              </div>
            </div>
          </div>

          {/* Products Section */}
          <div className="section">
            <h4 className="section-title text-lg font-bold text-blue-600 border-b-2 border-blue-200 pb-3 mb-4">
              Order Items
            </h4>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-blue-500 text-white">
                    <th className="p-3 text-left border border-gray-300">#</th>
                    <th className="p-3 text-left border border-gray-300">Product Name</th>
                    <th className="p-3 text-center border border-gray-300">Quantity</th>
                    <th className="p-3 text-right border border-gray-300">Unit Price</th>
                    <th className="p-3 text-right border border-gray-300">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {order.products.map((product, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="p-3 border border-gray-300 text-center font-semibold text-gray-600">
                        {index + 1}
                      </td>
                      <td className="p-3 border border-gray-300">
                        <div className="font-medium text-gray-800">
                          {product.productName.length > 60
                            ? product.productName.slice(0, 60) + '...'
                            : product.productName}
                        </div>
                      </td>
                      <td className="p-3 border border-gray-300 text-center font-semibold">
                        {product.quantity}
                      </td>
                      <td className="p-3 border border-gray-300 text-right font-semibold">
                        ${product.price.toFixed(2)}
                      </td>
                      <td className="p-3 border border-gray-300 text-right font-bold text-blue-600">
                        ${(product.price * product.quantity).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Payment and Summary Section */}
          <div className="info-grid grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* Payment Details */}
            <div className="section">
              <h4 className="section-title text-lg font-bold text-blue-600 border-b-2 border-blue-200 pb-3 mb-4">
                Payment Information
              </h4>
              {order.paymentDetails && order.paymentDetails.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-yellow-500 text-white">
                        <th className="p-2 text-left border border-gray-300 text-sm">Reference</th>
                        <th className="p-2 text-left border border-gray-300 text-sm">Method</th>
                        <th className="p-2 text-left border border-gray-300 text-sm">Phone</th>
                        <th className="p-2 text-right border border-gray-300 text-sm">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.paymentDetails.map((payment, index) => (
                        <tr key={index} className="hover:bg-yellow-50">
                          <td className="text-sm p-2 border border-gray-300 font-mono">
                            {payment.paymentReference}
                          </td>
                          <td className="text-sm p-2 border border-gray-300 font-semibold">
                            {payment.paymentMethod}
                          </td>
                          <td className="text-sm p-2 border border-gray-300">
                            {payment.phonenumber}
                          </td>
                          <td className="text-sm p-2 border border-gray-300 text-right font-bold">
                            ${payment.amount.toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-gray-500 italic">No payment information available</p>
              )}
            </div>

            {/* Order Summary */}
            <div className="section">
              <h4 className="section-title text-lg font-bold text-blue-600 border-b-2 border-blue-200 pb-3 mb-4">
                Order Summary
              </h4>
              <div className="bg-gray-50 p-4 rounded-lg">
                <table className="w-full">
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <td className="py-3 font-semibold text-gray-700">Subtotal:</td>
                      <td className="py-3 text-right font-semibold">${calculateSubtotal().toFixed(2)}</td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="py-3 font-semibold text-gray-700">Delivery Fees:</td>
                      <td className="py-3 text-right font-semibold">${order.totalDeliveryFees?.toFixed(2) || '0.00'}</td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="py-3 font-semibold text-gray-700">Tax:</td>
                      <td className="py-3 text-right font-semibold">${order.totalTax?.toFixed(2) || '0.00'}</td>
                    </tr>
                    <tr className="total-row bg-yellow-100 border-2 border-yellow-300">
                      <td className="py-4 font-bold text-lg text-gray-800">Total Amount:</td>
                      <td className="py-4 text-right font-bold text-lg text-blue-600">
                        ${order.totalOrderAmount?.toFixed(2) || '0.00'}
                      </td>
                    </tr>
                    <tr className="bg-green-100 border-2 border-green-300">
                      <td className="py-4 font-bold text-lg text-gray-800">Amount Paid:</td>
                      <td className="py-4 text-right font-bold text-lg text-green-600">
                        ${order.totalPaymentAmount?.toFixed(2) || '0.00'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="footer text-center border-t-2 border-blue-500 pt-6 mt-8">
            <p className="text-lg font-semibold text-blue-600 mb-2">Thank you for choosing QuickCrate Express!</p>
            <p className="text-gray-600 mb-2">
              For support or inquiries, contact us at support@quickcrate.co.ke or +254 720 463 710
            </p>
            <p className="text-sm text-gray-500">
              This is a computer-generated receipt. Please keep it for your records.
            </p>
            <div className="mt-4 text-xs text-gray-400">
              Receipt generated on {new Date().toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderModal;